// extracted by mini-css-extract-plugin
export default {"title":"style_title__bAQg1","title__name":"style_title__name__XCCw8"};